import { render, staticRenderFns } from "./PartCategoryList.vue?vue&type=template&id=955137ae"
import script from "./PartCategoryList.vue?vue&type=script&lang=ts"
export * from "./PartCategoryList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports